<script setup>
import { ref, computed } from 'vue'
import { useGlobalStore } from '@stores/global.js'
import AwardCard from '@components/about/AwardCard.vue'
import Button from '@components/global/forms/Button.vue'

const global = useGlobalStore()

const expandAwards = ref(false)
const awardBreakpoints = ref({
	'3xl': 20,
	'2xl': 20,
	xl: 8,
	lg: 6,
	md: 4,
	sm: 4,
	xs: 4,
})

const limit = computed(() => {
	return awardBreakpoints.value[global.breakpoint]
})

const awards = computed(() => {
	return global.awardPlatforms.slice(0, expandAwards.value ? global.awardPlatforms.length : limit.value)
})
</script>

<template>
	<section class="relative bg-crowns-dark-grey py-28">
		<div class="container">
			<div class="flex flex-col gap-12">
				<div class="flex flex-col items-center justify-center gap-5">
					<img class="max-h-32" src="https://cdn.papercrowns.com/website/images/elements/lockups/great-hall.svg" alt="Great Hall" />
					<p>Grandeur and glory, since 2019.</p>
				</div>
				<div class="grid grid-cols-1 gap-5 xs:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
					<AwardCard v-for="award in awards" :award="award" @click="global.setModal(['Award', award])" />
				</div>
				<div class="flex justify-center">
					<Button @click="expandAwards = !expandAwards" :label="expandAwards ? 'Collapse' : 'View all ' + global.awardPlatforms.length + ' awards'" v-if="global.awardPlatforms.length > limit" />
				</div>
			</div>
		</div>
	</section>
</template>
